import React from 'react';
import { TEAM_MANAGMENT_LABELS } from '../../../../../lib/constants/labelKeys';
import { ConfirmDialog } from '../../../../common/ConfirmDialog/ConfirmDialog';
import { useTeamMembersContext } from '../../../../../lib/context/TeamMembersContext';
import { SubteamDialogProps } from '../TeamAccordionItem.types';
import { replaceObjectPlaceholders } from '../../../../../lib/utils/placeholders/replacePlaceholder';
import { useDeleteTeam } from '../../../../../lib/api/postApi';
import useHandleAction from '../../../../../lib/hooks/useHandleAction';

const DeleteTeamDialog = ({ onClose, teamMeta }: SubteamDialogProps) => {
  const { refreshTeamsSummary, deleteTeamDialogTitle, deleteTeamSuccessMessage } = useTeamMembersContext();
  const deleteTeam = useDeleteTeam();
  const { handleAction, isPending } = useHandleAction({
    action: deleteTeam,
    successMessage: deleteTeamSuccessMessage,
    onSuccess: refreshTeamsSummary,
    onCompleted: onClose,
  });

  return (
    <ConfirmDialog
      onCancel={onClose}
      onConfirm={() => handleAction(teamMeta.id)}
      dialogTitle={replaceObjectPlaceholders(teamMeta, deleteTeamDialogTitle)}
      confirmButtonStatus={isPending ? 'loading' : 'enabled'}
      isOpen
      labelKeys={{
        confirmButton: TEAM_MANAGMENT_LABELS.deleteTeamDialog.CONFIRM_BUTTON,
        content: TEAM_MANAGMENT_LABELS.deleteTeamDialog.CONTENT,
      }}
    />
  );
};

export default DeleteTeamDialog;
